// extracted by mini-css-extract-plugin
export default {"list":"listRegisterItem_list__6esVy","list__route":"listRegisterItem_list__route__AijyW","red_circle":"listRegisterItem_red_circle__M5Hw0"};